<template>
  <validation-observer v-slot="{ invalid }">
    <b-row>
      <b-col>
        <b-card class="mb-0 mt-0" body-class="p-2">
          <!-- 踏切情報登録ボタン -->
          <b-row>
            <b-col cols="2" offset="10">
              <b-button
                id="createButton"
                variant="primary"
                @click="clickCreateButton">
                <span>踏切情報登録</span>
                <b-spinner
                  v-show="buttonstates.createButton"
                  class="ml-1"
                  small>
                </b-spinner>
              </b-button>
            </b-col>
          </b-row>
          <b-table
            :fields="tableFields"
            :items="tableItems"
            :empty-text="'データがありません'"
            hover
            responsive
            show-empty
            class="p-1 text-nowrap table-sm"
            no-local-sorting>
            <!-- 変更ボタン -->
            <template v-slot:cell(changeButton)="{ item }">
              <b-button
                :id="createId('changeButton', item)"
                @click="clickChangeButton(item.crossingId, createId('changeButton', item))"
                variant="primary">
                <span>変更</span>
                <b-spinner
                  v-show="buttonstates[createId('changeButton', item)]"
                  class="ml-1"
                  small>
                </b-spinner>
              </b-button>
            </template>
            <!-- 削除ボタン -->
            <template v-slot:cell(deleteButton)="{ item }">
              <b-button
                id="deleteButton"
                @click="clickDeleteButton(item)"
                variant="danger">
                <span>削除</span>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>

      <!-- 踏切情報登録モーダル -->
      <b-modal
        v-model="modal.registration"
        title="踏切情報登録"
        size="xl"
        no-close-on-backdrop>
        <b-container fluid>
          <b-row class="mb-1">
            <b-col class="border-bottom">
              <h5>■踏切情報</h5>
            </b-col>
          </b-row>
          <br />
          <!-- 踏切情報登録モーダル.表示順 -->
          <b-row class="mb-1">
            <b-col cols="3">表示順</b-col>
            <b-col>
              <validation-provider
                v-slot="validationContext"
                rules="required|min_value:1|max_value:999999999"
                name="表示順">
                <b-form-input
                  id="modalOrderNumber"
                  type="number"
                  min="1"
                  max="999999999"
                  v-model="modalItems.orderNumber"
                  :state="getValidationState(validationContext)"
                  :disabled="isProcessing">
                </b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- 踏切情報登録モーダル.運行指令所名 -->
          <b-row class="mb-1">
            <b-col cols="3">運行指令所名</b-col>
            <b-col>
              <validation-provider
                v-slot="validationContext"
                rules="required"
                name="運行指令所名">
                <b-form-select
                  id="modalAffiliationId"
                  v-model="modalItems.affiliationId"
                  :options="modalItems.affiliationOptions"
                  :state="getValidationState(validationContext)"
                  :disabled="isProcessing">
                </b-form-select>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- 踏切情報登録モーダル.踏切名 -->
          <b-row class="mb-1">
            <b-col cols="3">踏切名</b-col>
            <b-col>
              <validation-provider
                v-slot="validationContext"
                rules="required|max:100"
                name="踏切名">
                <b-form-input
                  id="modalCrossingName"
                  type="text"
                  v-model="modalItems.crossingName"
                  :state="getValidationState(validationContext)"
                  :disabled="isProcessing">
                </b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- モーダル.踏切名(かな) -->
          <b-row class="mb-1">
            <b-col cols="3">踏切名(かな)</b-col>
            <b-col>
              <validation-provider
                v-slot="validationContext"
                :rules="{ required: true, regex: /^[ぁ-んー]*$/, max: 20 }"
                name="踏切名(かな)">
                <b-form-input
                  id="modalCrossingNameKana"
                  type="text"
                  v-model="modalItems.crossingNameKana"
                  :state="getValidationState(validationContext)"
                  :disabled="isProcessing">
                </b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <!-- モーダル.待機時間(秒) -->
          <b-row class="mb-1">
            <b-col cols="3">待機時間(秒)</b-col>
            <b-col>
              <validation-provider
                v-slot="validationContext"
                rules="required|min_value:0|max_value:600|decimal"
                name="待機時間(秒)">
                <b-form-input
                  id="modalWaitTime"
                  type="number"
                  step="0.1"
                  min="0"
                  max="600"
                  v-model="modalItems.waitTime"
                  :state="getValidationState(validationContext)"
                  :disabled="isProcessing">
                </b-form-input>
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </validation-provider>
            </b-col>
          </b-row>
          <br />
          <br />
          <b-row class="mb-1">
            <b-col class="border-bottom">
              <h5>■設置情報</h5>
            </b-col>
          </b-row>
          <b-row align-h="end">
            <b-col cols="2">
              <b-button
                id="rowAddButton"
                variant="primary"
                @click="addItem"
                :disabled="isProcessing">
                <span>行追加</span>
              </b-button>
            </b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col>
              <section id="pegging">
                <b-table
                  :fields="modalTableFields"
                  :items="modalItems.installationData"
                  :empty-text="'データがありません'"
                  hover
                  responsive
                  show-empty
                  class="p-1 text-nowrap table-sm"
                  no-local-sorting>
                  <!-- モーダル.設置場所名 -->
                  <template v-slot:cell(locationName)="{ item }">
                    <validation-provider
                      v-slot="validationContext"
                      rules="required|max:100"
                      name="設置場所名">
                      <b-form-input
                        v-model="item.locationName"
                        type="text"
                        placeholder="設置場所名"
                        :state="getValidationState(validationContext)"
                        :disabled="isProcessing">
                      </b-form-input>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </template>
                  <!-- モーダル.エッジ製造番号 -->
                  <template v-slot:cell(edgeProductNumber)="{ item }">
                    <validation-provider
                      v-slot="validationContext"
                      :rules="{required: true}"
                      name="エッジ製造番号">
                      <b-form-select
                        v-model="item.edgeId"
                        :options="modalItems.edgeProductNumberOptions"
                        :state="getValidationState(validationContext)"
                        :disabled="isProcessing">
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </template>
                  <!-- モーダル.カメラ製造番号 -->
                  <template v-slot:cell(cameraProductNumber)="{ item }">
                    <validation-provider
                      v-slot="validationContext"
                      rules="required"
                      name="カメラ製造番号">
                      <b-form-select
                        v-model="item.cameraId"
                        :options="modalItems.cameraProductNumberOptions"
                        :state="getValidationState(validationContext)"
                        :disabled="isProcessing">
                      </b-form-select>
                      <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </validation-provider>
                  </template>
                  <!-- モーダル.紐付開始日 -->
                  <template v-slot:cell(linkingStartDate)="{ item }">
                    <date-picker
                      v-model="item.linkingStartDate"
                      :config="datePickerOptions"
                      :id="createId('linkingStartDate', item)"
                      :disabled="isProcessing"
                      style='position:relative'
                    >
                    </date-picker>
                  </template>
                  <!-- モーダル.紐付終了日 -->
                  <template v-slot:cell(linkingEndDate)="{ item }">
                    <date-picker
                      v-model="item.linkingEndDate"
                      :config="datePickerOptions"
                      :id="createId('linkingStartDate', item)"
                      :disabled="isProcessing"
                      style='position:relative'
                    >
                    </date-picker>
                  </template>
                  <!-- モーダル.試運用 -->
                  <template v-slot:cell(trialFlag)="{ item }">
                    <b-form-checkbox
                      v-model="item.trialFlag"
                      :disabled="isProcessing">
                    </b-form-checkbox>
                  </template>
                  <!-- モーダル.削除 -->
                  <template v-slot:cell(deleteButton)="{ item }">
                    <b-button
                      @click="deleteItem(item)"
                      variant="danger"
                      :disabled="isProcessing">
                      <span>行削除</span>
                    </b-button>
                  </template>
                </b-table>
              </section>
            </b-col>
          </b-row>
        </b-container>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            id="modalCancelButton"
            variant="secondary"
            @click="cancel()"
            :disabled="isProcessing">
            <span>キャンセル</span>
          </b-button>
          <b-button
            id="modalregistrationButton"
            variant="primary"
            @click="registrationBtn()"
            :disabled="invalid || isProcessing">
            <span>登録</span>
            <b-spinner
              v-show="isProcessing"
              class="ml-1"
              small>
            </b-spinner>
          </b-button>
        </template>
      </b-modal>

      <!-- 削除確認モーダル -->
      <b-modal
        v-model="modal.deleteConfirmation"
        title="削除確認"
        header-bg-variant="warning"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop>
        <span>踏切を削除しますが、よろしいでしょうか？</span>
        <template v-slot:modal-footer="{ cancel }">
          <b-button
            variant="secondary"
            @click="cancel()">
            <span>キャンセル</span>
          </b-button>
          <b-button
            variant="danger"
            @click="deleteConfirmationBtn()">
            <span>削除</span>
            <b-spinner
              v-show="isProcessing"
              class="ml-1"
              small>
            </b-spinner>
          </b-button>
        </template>
      </b-modal>

    </b-row>
  </validation-observer>
</template>

<script>
  import API from "@/api/index"
  import {mapGetters, mapMutations} from "vuex"
  import {operations} from '@/shared/operations'
  import Moment from 'moment'

  // Import this component
  import datePicker from 'vue-bootstrap-datetimepicker'
  // Import date picker css
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

  export default {
    components: {datePicker},
    name: 'RailroadCrossingMaintenance',
    data() {
      return {
        // ダイアログを多重に表示させない為のフラグ
        alreadyDialogDisplayed: false,
        // エラーダイアログの表示状態
        alreadyErrorDialogDisplayed: false,

        // 踏切情報一覧
        tableItems: [],
        // 選択行の踏切ID
        selectedCrossingId: null,
        // モーダル
        modal: {
          registration: false,
          deleteConfirmation: false,
        },
        modalItems: [],
        // ボタン状態
        buttonstates: {},
        // 編集状態
        editting: null,
        datePickerOptions: {
          format: 'YYYY/MM/DD HH:mm',
          useCurrent: false,
          showClear: true,
          locale: Moment.locale('ja'),
          showTodayButton: true,
        },
      }
    },

    computed: {
      ...mapGetters("auth", ['idToken', 'clientId', 'affiliationId']),
      ...mapGetters("componentState", ['isProcessing']),

      // エラーダイアログのプロパティ
      errorDialogProps() {
        return {
          title: 'エラー',
          headerBgVariant: 'danger',
          hideHeaderClose: true,
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        }
      },

      // 成功ダイアログのプロパティ
      successDialogProps() {
        return {
          title: '成功',
          headerBgVariant: 'success',
          hideHeaderClose: true,
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        }
      },

      // 踏切情報登録.テーブルカラム
      tableFields() {
        return [
          { key: 'orderNumber', label: '表示順', sortable: false },
          { key: 'affiliationName', label: '運行指令所名', sortable: false },
          { key: 'crossingName', label: '踏切名', sortable: false },
          { key: 'waitTime', label: '待機時間', sortable: false },
          { key: 'locationNames', label: 'カメラ設置場所', sortable: false },
          { key: 'changeButton', label: '', sortable: false },
          { key: 'deleteButton', label: '', sortable: false },
        ]
      },

      // 踏切情報登録モーダル.設置情報.テーブルカラム
      modalTableFields() {
        return [
          { key: 'locationName', label: 'カメラ設置場所', sortable: false },
          { key: 'edgeProductNumber', label: 'エッジ製造番号', sortable: false },
          { key: 'cameraProductNumber', label: 'カメラ製造番号', sortable: false },
          { key: 'linkingStartDate', label: '紐付開始日', sortable: false },
          { key: 'linkingEndDate', label: '紐付終了日', sortable: false },
          { key: 'trialFlag', label: '試運用', sortable: false, tdClass: 'text-center align-middle' },
          { key: 'deleteButton', label: '', sortable: false },
        ]
      },

      // 登録・更新用パラメータ
      registrationOrUpdateParams() {
        const item = this.modalItems
        // 設置情報部分
        const installationData = item.installationData.map(function(data) {
          var pushData = {}
          // 踏切_エッジ_カメラ紐付けID
          if (data.crossingEdgeCameraId) {
            pushData.crossingEdgeCameraId = Number(data.crossingEdgeCameraId)
          }
          pushData.locationName = data.locationName
          pushData.edgeId = Number(data.edgeId)
          pushData.cameraId = Number(data.cameraId)
          pushData.linkingStartDate = Moment(data.linkingStartDate).utc().format()
          // 紐付け終了日
          if (data.linkingEndDate) {
            pushData.linkingEndDate = Moment(data.linkingEndDate).utc().format()
          }
          pushData.trialFlag = data.trialFlag ? 1 : 0
          return pushData
        })
        // 返却パラメータ
        var params = {}
        params.clientId = Number(this.clientId)
        params.affiliationId = Number(this.affiliationId)
        params.crossingName = item.crossingName
        params.crossingNameKana = item.crossingNameKana
        params.waitTime = Number(item.waitTime) * 1000
        params.orderNumber = Number(item.orderNumber)
        params.installationData = installationData
        // 更新の場合
        if (item.crossingId) {
          params.crossingId = Number(item.crossingId)
          params.updateDate = item.updateDate
        }
        return params
      },

      // 削除用パラメータ
      deleteParams() {
        const item = this.modalItems
        return {
          clientId: Number(this.clientId),
          affiliationId: Number(this.affiliationId),
          crossingId: Number(item.crossingId),
          updateDate: item.updateDate
        }
      },
    },
    // 画面の初期表示時
    async created() {
      await this.initialize()
    },

    // 画面の終了時
    beforeDestroy() {},

    methods: {
      ...mapMutations("componentState", [
        'turnLoadingOn',
        'turnLoadingOff',
      ]),

      // バリデーション
      getValidationState: ({dirty, validated, valid = null}) => dirty || validated ? valid : null,

      // ID作成
      createId(fixId, item) {
        return fixId + item.__ob__.dep.id
      },

      // 初期化処理
      async initialize() {
        // 踏切情報の取得(複数件)
        const railroadCrossing = await this.getRailroadCrossing(null)
        this.tableItems = railroadCrossing
        return
      },

      // 踏切情報の取得
      async getRailroadCrossing(crossingId) {
        try {
          var railroadCrossing = null
          // 踏切情報の取得
          var queryParamArray = []
          queryParamArray.push('?client_id=')
          queryParamArray.push(this.clientId)
          queryParamArray.push('&affiliation_id=')
          queryParamArray.push(this.affiliationId)
          if (crossingId) {
            queryParamArray.push('&crossing_id=')
            queryParamArray.push(crossingId)
          }
          const queryParam = queryParamArray.join('')
          railroadCrossing = await API.railroadCrossing.get(this.idToken(), {path: queryParam})

          // 取得データの編集
          railroadCrossing.data.forEach(function(data) {
            // 待機時間の編集(単位をmsecからsecに変換)
            data.waitTime = (data.waitTime) / 1000
            // カメラ設置場所の編集(複数の場合、カンマで結合)
            var locationNames = []
            data.installationData.forEach(function(item) {
              const fromDate = new Date(item.linkingStartDate).getTime()
              const toDate = item.linkingEndDate == null ? 
                new Date('2999-12-31 23:59:59').getTime() :
                new Date(item.linkingEndDate).getTime()
              const nowDate = new Date().getTime()
              if (fromDate <= nowDate && nowDate <= toDate) {
                locationNames.push(item.locationName)
              }
            })
            data.locationNames = locationNames.join(',')
          })
          return railroadCrossing.data
        } catch (error) {
          // レスポンスを持っているか
          if (!(error && error.hasOwnProperty('response'))) return
          // ステータスコードを持っているか
          if (!(error.response && error.response.hasOwnProperty('status'))) return
          if (error.response.status === 403)
            return this.$router.push({ path: '/session-timeout' })
          await this.showErrorDialog('踏切情報の取得に失敗しました。')
        }
      },

      // 運行指令所のプルダウンを作成
      async createAffiliationOption() {
        const affiliations = await API.operationCommandCenter.get(
            this.idToken(), {path: '?affiliation_id=' + this.affiliationId})
        var affiliationOptions = []
        affiliationOptions.push({ value: null, text: '' })
        affiliations.data.forEach(
          item => affiliationOptions.push({ value: item.affiliationId, text: item.affiliationName })
        )
        return affiliationOptions
      },

      // エッジ製造番号のプルダウンを作成
      async createEdgeProductNumberOption() {
        const edges = await API.edgeDevice.get(
            this.idToken(), {path: '?client_id=' + this.clientId})
        var edgeProductNumberOptions = []
        edgeProductNumberOptions.push({ value: null, text: '' })
        edges.data.forEach(item => edgeProductNumberOptions.push(
          { value: item.edgeId, text: item.edgeProductNumber })
        )
        return edgeProductNumberOptions
      },

      // カメラ製造番号のプルダウンを作成
      async createCameraProductNumberOption() {
        const cameras = await API.camera.get(
            this.idToken(), {path: '?client_id=' + this.clientId})
        var cameraProductNumberOptions = []
        cameraProductNumberOptions.push({ value: null, text: '' })
        cameras.data.forEach(item => cameraProductNumberOptions.push(
          { value: item.cameraId, text: item.cameraProductNumber })
        )
        return cameraProductNumberOptions
      },

      // 踏切情報登録モーダルの初期化
      initModal() {
        this.modalItems = {
          // 踏切名
          crossingName: null,
          // 踏切名(かな)
          crossingNameKana: null,
          // 所属ID
          affiliationId: null,
          // 踏切待機時間
          waitTime: null,
          // 表示順
          orderNumber: null,
          // 設置情報
          installationData: [],
        }
      },

      // 新規登録ボタン押下時
      async clickCreateButton() {
        // 押下ボタンのスピナーを表示
        this.buttonstates.createButton = true
        // 編集状態の変更
        this.editting = operations.register.en
        // 踏切情報登録モーダルの初期化
        this.initModal()
        // 踏切情報登録モーダル.運行指令所名
        const affiliationOption = await this.createAffiliationOption()
        this.modalItems.affiliationOptions = affiliationOption
        this.modalItems.affiliationId = this.affiliationId
        // エッジ製造番号のプルダウン
        const edgeProductNumberOptions = await this.createEdgeProductNumberOption()
        this.modalItems.edgeProductNumberOptions = edgeProductNumberOptions
        // カメラ製造番号のプルダウン
        const cameraProductNumberOptions = await this.createCameraProductNumberOption()
        this.modalItems.cameraProductNumberOptions = cameraProductNumberOptions
        // 押下ボタンのスピナーを非表示
        this.buttonstates.createButton = false
        // モーダル表示
        this.modal.registration = true
      },

      // 変更ボタン押下時
      async clickChangeButton(crossingId, buttonId) {
        // 押下ボタンのスピナーを表示
        this.buttonstates[buttonId] = true
        // 編集状態の変更
        this.editting = operations.update.en

        // 踏切情報の取得(単一件)
        const railroadCrossing = await this.getRailroadCrossing(crossingId)
        // 取得情報なし
        if (!railroadCrossing.length) {
          await this.$bvModal.msgBoxOk(`他者によって情報が削除されています`, this.errorDialogProps)
          .then(async () => { await this.initialize() })
          .catch(() => {})
        // 取得情報あり
        } else {
          // 踏切情報登録モーダルの初期化
          this.initModal()

          const data = railroadCrossing[0]

          // 踏切情報登録モーダル.表示順
          this.modalItems.orderNumber = data.orderNumber
          // 踏切情報登録モーダル.運行指令所名
          const affiliationOption = await this.createAffiliationOption()
          this.modalItems.affiliationOptions = affiliationOption
          this.modalItems.affiliationId = data.affiliationId
          // 踏切情報登録モーダル.踏切ID
          this.modalItems.crossingId = data.crossingId
          // 踏切情報登録モーダル.踏切名
          this.modalItems.crossingName = data.crossingName
          // 踏切情報登録モーダル.踏切名(かな)
          this.modalItems.crossingNameKana = data.crossingNameKana
          // 踏切情報登録モーダル.待機時間
          this.modalItems.waitTime = data.waitTime
          // 踏切情報登録モーダル.更新日時
          this.modalItems.updateDate = data.updateDate

          // エッジ製造番号のプルダウン
          const edgeProductNumberOptions = await this.createEdgeProductNumberOption()
          this.modalItems.edgeProductNumberOptions = edgeProductNumberOptions
          // カメラ製造番号のプルダウン
          const cameraProductNumberOptions = await this.createCameraProductNumberOption()
          this.modalItems.cameraProductNumberOptions = cameraProductNumberOptions

          // 設置情報
          if (data.installationData[0].crossingEdgeCameraId) {
            data.installationData.forEach(function(item) {
              // エッジ製造番号
              var option = edgeProductNumberOptions.find(option => option.value === item.edgeId)
              item.edgeProductNumber = option.text
              // カメラ製造番号
              option = cameraProductNumberOptions.find(option => option.value === item.cameraId)
              item.cameraProductNumber = option.text
              // 紐付開始日(UTC ⇒ JST)
              const dateStart = new Date(item.linkingStartDate)
              var strStart = []
              strStart.push(String(dateStart.getFullYear()))
              strStart.push('-')
              strStart.push(('0' + String(dateStart.getMonth() + 1)).slice(-2))
              strStart.push('-')
              strStart.push(('0' + String(dateStart.getDate())).slice(-2))
              strStart.push(' ')
              strStart.push(('0' + String(dateStart.getHours())).slice(-2))
              strStart.push(':')
              strStart.push(('0' + String(dateStart.getMinutes())).slice(-2))
              item.linkingStartDate = strStart.join('')
              // 紐付終了日(UTC ⇒ JST)
              if (item.linkingEndDate) {
                const dateEnd = new Date(item.linkingEndDate)
                var strEnd = []
                strEnd.push(String(dateEnd.getFullYear()))
                strEnd.push('-')
                strEnd.push(('0' + String(dateEnd.getMonth() + 1)).slice(-2))
                strEnd.push('-')
                strEnd.push(('0' + String(dateEnd.getDate())).slice(-2))
                strEnd.push(' ')
                strEnd.push(('0' + String(dateEnd.getHours())).slice(-2))
                strEnd.push(':')
                strEnd.push(('0' + String(dateEnd.getMinutes())).slice(-2))
                item.linkingEndDate = strEnd.join('')
              }
              // 試運用フラグ
              item.trialFlag = item.trialFlag ? true : false
            })
            this.modalItems.installationData = data.installationData
          }
          // モーダル表示
          this.modal.registration = true
        }
        // 押下ボタンのスピナーを非表示
        this.buttonstates[buttonId] = false
      },

      // 削除ボタン押下時
      async clickDeleteButton(item) {
        // 削除用パラメータ設定
        this.modalItems = item
        // モーダル表示
        this.modal.deleteConfirmation = true
      },

      // 踏切情報登録モーダル.設置情報.行追加ボタン押下時
      addItem() {
        // 初期値
        const item = {
          locationName: null,
          edgeId: null,
          cameraId: null,
          linkingStartDate: null,
          linkingEndDate: null,
          trialFlag: false,
        }
        this.modalItems.installationData.push(item)
      },

      // 踏切情報登録モーダル.設置情報.行削除ボタン押下時
      deleteItem(item) {
        const newItems = this.modalItems.installationData.filter(n => n !== item)
        this.modalItems.installationData = newItems
      },

      // 踏切情報登録モーダル.ヘッダー.登録ボタン押下時
      async registrationBtn() {
        // 押下ボタンのスピナーを表示
        this.turnLoadingOn()
        if (this.modalItems.installationData.length) {
          // 単項目チェック
          var errMsg = await this.single()
          if (errMsg) {
            // 押下ボタンのスピナーを非表示
            this.turnLoadingOff()
            return this.$bvModal.msgBoxOk(errMsg, this.errorDialogProps)
          }
          // 相関チェック
          errMsg = await this.correlation()
          if (errMsg) {
            // 押下ボタンのスピナーを非表示
            this.turnLoadingOff()
            return this.$bvModal.msgBoxOk(errMsg, this.errorDialogProps)
          }
        }
        // 登録 または 更新
        await this.operateData(this.editting)
        // 押下ボタンのスピナーを非表示
        this.turnLoadingOff()
      },

      // 削除確認ボタン押下時
      async deleteConfirmationBtn() {
        // 削除確認モーダルを閉じる
        this.modal.deleteConfirmation = false
        // 削除
        this.turnLoadingOn()
        await this.operateData(operations.delete.en)
        this.turnLoadingOff()
      },

      // 単項目チェック
      async single() {
        var errMsg = ''
        const items = this.modalItems.installationData

        // ■ 紐付開始日
        items.forEach(function(item) {
          if (!item.linkingStartDate) {
            errMsg = '紐付開始日が入力されていません。'
            return
          }
        })
        if (errMsg) return errMsg
        return null
      },

      // 相関チェック
      async correlation() {
        var errMsg = ''
        const items = this.modalItems.installationData

        // ■ 登録情報内
        // 紐付開始日と紐付終了日の整合性チェック
        items.forEach(function(item) {
          var startDate = new Date(item.linkingStartDate)
          var endDate = item.linkingEndDate
              ? new Date(item.linkingEndDate) : new Date('2999-12-31 23:59:59')
          if (startDate.getTime() > endDate.getTime()) {
            errMsg = '紐付開始日 ≦ 紐付終了日となっていません。'
            return
          }
        })
        if (errMsg) return errMsg

        // 以降は設置情報が2つ以上ある場合のチェック
        if (items.length === 1) return null

        // カメラ設置場所の重複チェック
        var correlationLocationNameResult = null
        correlationLocationNameResult = await this.duplicateCheck(items, 'locationName')
        if (correlationLocationNameResult) {
          const option = this.modalItems.edgeProductNumberOptions.find(
            option => option.value === correlationLocationNameResult
          )
          return '踏切内で、カメラ設置場所が重複しています。'
        }

        // エッジ製造番号の重複チェック
        var duplicateResult = null
        duplicateResult = await this.duplicateCheck(items, 'edgeId')
        if (duplicateResult) {
          const option = this.modalItems.edgeProductNumberOptions.find(
            option => option.value === duplicateResult
          )
          return '踏切内で、エッジ製造番号[ ' +
              option.text +
              ' ]の紐付日期間が重複しています。'
        }
        // カメラ製造番号の重複チェック
        duplicateResult = await this.duplicateCheck(items, 'cameraId')
        if (duplicateResult) {
          const option = this.modalItems.cameraProductNumberOptions.find(
            option => option.value === duplicateResult
          )
          return '踏切内で、カメラ製造番号[ ' +
              option.text +
              ' ]の紐付日期間が重複しています。'
        }

        // ■ 踏切_エッジ_カメラ紐付けテーブル内での重複チェックはAPI側で実施
      },

      async duplicateCheck(items, targetName) {
        var duplicateResult = null
        var targets = []
        items.forEach(item => targets.push(item[targetName]))
        var duplicateTargets = targets.filter(function(x, i, self) {
          // 重複している【targetName】の値を取得
          return self.indexOf(x) === i && i !== self.lastIndexOf(x)
        })
        // 【targetName】の値が重複している場合、紐付日期間の重複チェックを実施
        if (duplicateTargets.length) {
          const NULL_CASE_DATETIME = '2999-12-31 23:59:59'
          duplicateTargets.forEach(function(duplicateTarget) {
            // 【targetName】が同じ値の行データを取得
            var duplicateItems = []
            items.forEach(function(item) {
              if (item[targetName] === duplicateTarget) {
                duplicateItems.push(item)
              }
            })
            // 【targetName】が同じ値の行データを、紐付開始日で昇順ソート
            duplicateItems.sort(function(first, second) {
              const firstStartDate = new Date(first.linkingStartDate)
              const secondStartDate = new Date(second.linkingStartDate)
              return firstStartDate.getTime() < secondStartDate.getTime() ? -1 : 1
            })
            // 【targetName】が同じ値の行データで、紐付日期間の重複チェック
            duplicateItems.forEach(function(item, index) {
              if (index !== duplicateItems.length - 1) {
                var first = {
                  startDate: new Date(item.linkingStartDate),
                  endDate: item.linkingEndDate
                    ? new Date(item.linkingEndDate)
                    : new Date(NULL_CASE_DATETIME),
                }
                var second = {
                  startDate: new Date(duplicateItems[index + 1].linkingStartDate),
                  endDate: duplicateItems[index + 1].linkingEndDate
                    ? new Date(duplicateItems[index + 1].linkingEndDate)
                    : new Date(NULL_CASE_DATETIME),
                }
                // 紐付日期間が重複している場合、【targetName】の値をセットする
                if (
                  first.startDate.getTime() <= second.endDate.getTime() &&
                  first.endDate.getTime() >= second.startDate.getTime()
                ) {
                  duplicateResult = duplicateTarget
                  return
                }
              }
            })
            // 【targetName】の値がセットされている場合、返却する
            if (duplicateResult) return duplicateResult
          })
        }
        return duplicateResult
      },

      // 登録・更新・削除処理
      async operateData(operation) {
        try {
          await this.operateAPI(operation)
          var operationName = null
          switch (operation) {
            case operations.register.en:
            case operations.update.en:
              operationName = this.getOperationName(operations.register.en)
              break
            case operations.delete.en:
              operationName = this.getOperationName(operations.delete.en)
              break
          }
          this.$bvModal.msgBoxOk(
              `${operationName}が完了しました。`, this.successDialogProps)
            .then(async() => {
                switch (operation) {
                  case operations.register.en:
                  case operations.update.en:
                    this.modal.registration = false
                    break
                  case operations.delete.en:
                }
                await this.initialize()
              })
            .catch(() => {}
          )
        } catch (error) {
          // レスポンスを持っているか
          if (!(error && error.hasOwnProperty('response'))) return
          // ステータスコードを持っているか
          if (!(error.response && error.response.hasOwnProperty('status'))) return
          if (error.response.status === 403) return this.$router.push({path: '/session-timeout'})
          // エラーメッセージ設定
          await this.showErrorDialog(this.createErrorMessage(error))
          if (error.response.status === 409) {
            this.modal.registration = false
            await this.initialize()
          }
          return
        }
      },

      // APIの呼び出し
      async operateAPI(operation) {
        switch (operation) {
          // 登録
          case operations.register.en:
            return API.railroadCrossing.post(
                this.idToken(), {data: this.registrationOrUpdateParams})
          // 更新
          case operations.update.en:
            return API.railroadCrossing.post(
                this.idToken(), {data: this.registrationOrUpdateParams})
          // 削除
          case operations.delete.en:
            return API.railroadCrossing.delete(this.idToken(), {data: this.deleteParams})
        }
      },

      // パラメータを日本語表記に変換
      getOperationName(operation) {
        switch (operation) {
          case operations.register.en:
            return operations.register.ja
          case operations.update.en:
            return operations.update.ja
          case operations.delete.en:
            return operations.delete.ja
        }
      },

      // エラーメッセージの作成
      createErrorMessage(error) {
        let result = error.response.data
        return result
      },

      // エラーダイアログの表示
      async showErrorDialog(errorMessage) {
        this.alreadyDialogDisplayed = true
        // 既にエラーダイアログが表示されている場合は重ねて表示しない
        if (this.alreadyErrorDialogDisplayed === true) return
        this.alreadyErrorDialogDisplayed = true
        await this.$bvModal.msgBoxOk(
          `${errorMessage}`, this.errorDialogProps)
          .then(async () => {
          })
          .catch(() => {
            this.alreadyDialogDisplayed = false
            this.alreadyErrorDialogDisplayed = false
          })
        this.alreadyDialogDisplayed = false
        this.alreadyErrorDialogDisplayed = false
      },
    },
  }
</script>
<style lang="scss" scoped>
</style>
